import { useMutation } from "@tanstack/react-query";
import { axiosInstance } from "../../axios";

const createBudgetary = async (data: any) => {
  return await axiosInstance
    .patch("quotes/createFirm", data)
    .then((res) => res.data)
    .catch((e) => {
      throw e;
    });
};

const useCreateBudgetaryMutation = () => {
  return useMutation({
    mutationFn: (data: any) => createBudgetary(data),
    mutationKey: ["quotes"],
  });
};
export default useCreateBudgetaryMutation;
